var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner pa-4"},[_c('v-container',{staticClass:"custom-container"},[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12","lg":"6"}},[_c('RmsSettingsView')],1),_c('v-col',{attrs:{"cols":"12","lg":"6"}},[_c('ChangeSettingsView')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }